var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF5DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6340_118075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5L18.5 13.5",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 14.3333C14.1468 14.3333 14.3333 14.1468 14.3333 13.9167C14.3333 13.6865 14.1468 13.5 13.9167 13.5C13.6865 13.5 13.5 13.6865 13.5 13.9167C13.5 14.1468 13.6865 14.3333 13.9167 14.3333Z",
    fill: "#E2AA01",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0832 18.5003C18.3133 18.5003 18.4998 18.3138 18.4998 18.0837C18.4998 17.8535 18.3133 17.667 18.0832 17.667C17.8531 17.667 17.6665 17.8535 17.6665 18.0837C17.6665 18.3138 17.8531 18.5003 18.0832 18.5003Z",
    fill: "#E2AA01",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1666 12.0004C10.1666 11.5142 10.3597 11.0478 10.7035 10.704C11.0474 10.3602 11.5137 10.1671 11.9999 10.1671H12.8332C13.3173 10.1668 13.7816 9.97505 14.1249 9.63372L14.7082 9.05038C14.8786 8.87905 15.0812 8.74309 15.3043 8.65031C15.5274 8.55753 15.7666 8.50977 16.0082 8.50977C16.2499 8.50977 16.4891 8.55753 16.7122 8.65031C16.9353 8.74309 17.1379 8.87905 17.3082 9.05038L17.8916 9.63372C18.2348 9.97505 18.6991 10.1668 19.1832 10.1671H20.0166C20.5028 10.1671 20.9691 10.3602 21.3129 10.704C21.6567 11.0478 21.8499 11.5142 21.8499 12.0004V12.8337C21.8502 13.3178 22.0419 13.7821 22.3832 14.1254L22.9666 14.7087C23.1379 14.8791 23.2739 15.0817 23.3666 15.3048C23.4594 15.5279 23.5072 15.7671 23.5072 16.0087C23.5072 16.2503 23.4594 16.4896 23.3666 16.7127C23.2739 16.9358 23.1379 17.1383 22.9666 17.3087L22.3832 17.8921C22.0419 18.2353 21.8502 18.6996 21.8499 19.1837V20.0171C21.8499 20.5033 21.6567 20.9696 21.3129 21.3134C20.9691 21.6572 20.5028 21.8504 20.0166 21.8504H19.1832C18.6991 21.8507 18.2348 22.0424 17.8916 22.3837L17.3082 22.9671C17.1379 23.1384 16.9353 23.2743 16.7122 23.3671C16.4891 23.4599 16.2499 23.5077 16.0082 23.5077C15.7666 23.5077 15.5274 23.4599 15.3043 23.3671C15.0812 23.2743 14.8786 23.1384 14.7082 22.9671L14.1249 22.3837C13.7816 22.0424 13.3173 21.8507 12.8332 21.8504H11.9999C11.5137 21.8504 11.0474 21.6572 10.7035 21.3134C10.3597 20.9696 10.1666 20.5033 10.1666 20.0171V19.1837C10.1663 18.6996 9.97456 18.2353 9.63323 17.8921L9.0499 17.3087C8.87856 17.1383 8.7426 16.9358 8.64982 16.7127C8.55704 16.4896 8.50928 16.2503 8.50928 16.0087C8.50928 15.7671 8.55704 15.5279 8.64982 15.3048C8.7426 15.0817 8.87856 14.8791 9.0499 14.7087L9.63323 14.1254C9.97456 13.7821 10.1663 13.3178 10.1666 12.8337V12.0004Z",
    stroke: "#E2AA01",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6340_118075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.18abe176000b3c50f9a957057579f7f5.svg";
export { ForwardRef as ReactComponent };